<template>
  
    <div  class="media-list-container">
       
       <div class="media-item headr">
         <div class="title-container">{{$t('language.additional_media')}}</div>
       </div>
        <div class="media-item" v-for="(media,index) in medias" :key="index">
          
          <div @click="downloadFile(media)" class="tools-left">
            <div class="download-button">
              <font-awesome-icon v-if="media.type=='pdf'" icon='file-download' />
              <font-awesome-icon v-if="media.type=='mp3'" icon='dot-circle' />
              </div>
            
          </div>
          
          <div class="title-container">
            <div class="title" @click="downloadFile(media)">{{media.filename}}</div>
            
            <mp3-player v-if="media.type=='mp3'" :media="media" />

          </div>
          
          <div class="tools-right">
            <div class="type-text">{{media.type}}</div>
          </div>
        </div>
    </div>
</template>

<script>

import Mp3Player from '../../components/medialist/Mp3Player.vue';
import { fileSave } from '../../services/FileSave.js';


export default {
  name: 'media-list',
  props:{
    medias:{type:Array,default:()=>{[]}}
  },
  data(){
    return {
    }
  },
  components: {
    Mp3Player
  },
  computed:{
    
   
  },
  methods:{
   downloadFile(media){
     if(media.type=="pdf"){ 

      this.$store.dispatch('get_crossdomain_download',{media_id:media.id,fileName:media.filename}).then(
        result=>{
          var base64data= "data:application/pdf;base64,"+result.data.base64Data;
          fileSave.saveBase64ToFile(base64data, media.filename);
        })
       
      }
       if(media.type=="mp3"){ 
        //this.$store.dispatch('open_pdf',{link:media.url,fileName:media.filename,mimetype:"audio/mpeg"});
      }
   },
    
  },
  beforeDestroy(){
    
  },
  
  mounted(){

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.media-item{
  display:flex;
  padding:5px;
  border-bottom:1px solid #DDDDDD;
}

.title-container{
  flex:1;
  display:flex;
  align-items:center;
  overflow:hidden;
}
.headr{
  font-weight:bold;
  margin-top:10px;
  background-color:#DDDDDD;
}
.title{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
 flex:1;
}
.player{
  margin-left:5px;
  flex:1;
  display:flex;
  align-items:center;
  border:1px solid grey;
}
.audio-player:focus{
  outline:none;
}

.play-button{
  padding:0px 10px;
  border:1px solid grey;
}
.scrub-button{
  flex:1;
}
.tools-left, .tools-right{
  display:flex;
}

.download-button{

  padding:0px 10px;
  border-radius:2px;
  font-size:.9em;
  height:100%;
  display:flex;
  align-items:center;
  justify-content: center;
}

.type-text{
   padding:0px 10px;
 font-size:.7em;
 display:flex;
  align-items:center;
  min-width:40px;
}
</style>
